import { Component, OnInit } from '@angular/core';
import { ApiService } from '.././api.service';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { Cache } from '../cache';

declare var $: any;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  email: any;
  password: any;
  constructor(private _ApiService: ApiService , private _Router: Router , private _AppComponent: AppComponent) {
    this._ApiService.Profile().subscribe((res)=>{
      if(res.check === true) {
        this._AppComponent.refreshNotification()
        this._AppComponent.show2 = false;
        this._AppComponent.show = true;
      } else {
        this._AppComponent.show2 = true;
        this._AppComponent.show = false;
      }
    })
   }
  login(data: any) {
              this._AppComponent.Users = false;
              this._AppComponent.CashReceipts = false;
              this._AppComponent.Permession = false;
              this._AppComponent.Employees = false;
              this._AppComponent.Attendances = false;
              this._AppComponent.Salary = false;
              this._AppComponent.Branches = false;
              this._AppComponent.Suppliers = false;
              this._AppComponent.Category = false;
              this._AppComponent.Items = false;
              this._AppComponent.Sellers = false;
              this._AppComponent.Brokers = false;
              this._AppComponent.Customer = false;
              this._AppComponent.Visit = false;
              this._AppComponent.Offer = false;
              this._AppComponent.Quotations = false;
              this._AppComponent.Orders = false;
              this._AppComponent.Store = false;
              this._AppComponent.Request = false;
              this._AppComponent.Returns = false;
              this._AppComponent.Reports = false;
              this._AppComponent.Histoty = false;
              this._AppComponent.CashPayments = false;
              this._AppComponent.AccountsGuide = false;
              this._AppComponent.DailyRestrictions = false;
              this._AppComponent.GeneralReports = false;
              this._AppComponent.ReportsPrivate = false;
              this._AppComponent.PaymentsReport = false;
    $('.loading').css({display: 'block'});
    this._ApiService.login(data).subscribe((res0)=>{
      if(res0.check === true) {
        this._ApiService.Profile().subscribe((res)=>{
          $('.loading').css({display: 'none'});
        this._AppComponent.show2 = false;
        this._AppComponent.show = true;
        this._Router.navigate(['/users']);
        this._AppComponent.refreshNotification();
        // cache the creditional
        // Cache.set('login', {email: data.email, password: data.password});
        res.data.forEach((element: any) => {
          if(element.checked === 1) {
            if(element.name === 'Users') {
              this._AppComponent.Users = true
            } else if(element.name === 'GeneralReports') {
              this._AppComponent.GeneralReports = true
            } else if(element.name === 'PrivateReport') {
              this._AppComponent.ReportsPrivate = true
            } else if(element.name === 'PaymentsReport') {
              this._AppComponent.PaymentsReport = true
            } else if(element.name === 'DailyRestrictions') {
              this._AppComponent.DailyRestrictions = true
            } else if(element.name === 'CashReceipts') {
              this._AppComponent.CashReceipts = true
            } else if(element.name === 'Items') {
              this._AppComponent.Items = true
            } else if(element.name === 'Permession') {
              this._AppComponent.Permession = true
            } else if(element.name === 'Employees') {
              this._AppComponent.Employees = true
            } else if(element.name === 'Attendances') {
              this._AppComponent.Attendances = true
            } else if(element.name === 'Salary') {
              this._AppComponent.Salary = true
            } else if(element.name === 'Branches') {
              this._AppComponent.Branches = true
            } else if(element.name === 'Suppliers') {
              this._AppComponent.Suppliers = true
            } else if(element.name === 'Category') {
              this._AppComponent.Category = true
            } else if(element.name === 'Sellers') {
              this._AppComponent.Sellers = true
            } else if(element.name === 'Brokers') {
              this._AppComponent.Brokers = true
            } else if(element.name === 'Customer') {
              this._AppComponent.Customer = true
            } else if(element.name === 'Visit') {
              this._AppComponent.Visit = true
            } else if(element.name === 'Offer') {
              this._AppComponent.Offer = true
            } else if(element.name === 'Quotations') {
              this._AppComponent.Quotations = true
            } else if(element.name === 'Orders') {
              this._AppComponent.Orders = true
            } else if(element.name === 'Store') {
              this._AppComponent.Store = true
            } else if(element.name === 'Request') {
              this._AppComponent.Request = true
            } else if(element.name === 'Returns') {
              this._AppComponent.Returns = true
            } else if(element.name === 'Reports') {
              this._AppComponent.Reports = true
            } else if(element.name === 'Histoty') {
              this._AppComponent.Histoty = true
            } else if(element.name === 'CashPayments') {
              this._AppComponent.CashPayments = true
            } else if(element.name === 'AccountsGuide') {
              this._AppComponent.AccountsGuide = true
            }
          }
        });
        });
      } else {
        this._AppComponent.show2 = true;
        this._AppComponent.show = false;
        alert('Error In Information');
        $('.loading').css({display: 'none'});
      }
    })
  }

  static performLogin(data: any, service: any, router: any, action: any=null) {
    service.login(data).subscribe((res: any)=>{
      if(res.check === true) {
        // cache the creditional
        Cache.set('login', {email: data.email, password: data.password});
        if (action)
          action(res);

          //let path = window.location.hash.replace("#", "");
          //router.navigateByUrl(path);
        //router.navigate(['/users']);
      } else {
      }
    })
  }

  ngOnInit(): void {
  }

}
